export const removeNullOrEmptyStringProperties = obj => {
	for (const key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			if (obj[key] === '' || obj[key] === null) {
				delete obj[key]; // Delete the property is null or empty string.
			} else if (typeof obj[key] === 'object') {
				removeNullOrEmptyStringProperties(obj[key]);
			}
		}
	}
};
